import { MembershipProfileComplementaryItem } from '@models/membership/MembershipProfileComplementaryItem'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_MEMBERSHIP_PROFILES_URL, MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL } from '@utils/urls'

const fetchMembershipProfileComplementaryItems = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipProfileComplementaryItem[]>(
    MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL,
    params
  )

const fetchMembershipProfileComplementaryItemsById = (
  id: number,
  params?: TableParams
) =>
  SBAPI.Fetch<MembershipProfileComplementaryItem[]>(
    `${MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL}/${id}`,
    params
  )

const createMembershipProfileComplementaryItem = (
  complementaryItem: MembershipProfileComplementaryItem
) =>
  SBAPI.Post(`${MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL}`, complementaryItem)

const updateMembershipProfileComplementaryItem = (
  complementaryItem: Partial<MembershipProfileComplementaryItem>
) =>
  SBAPI.Put(
    `${MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`,
    complementaryItem
  )

const batchUpdateMembershipProfileComplementaryItems = (
  profileId: number,
  items: { id: number; quantity: number }[]
) =>
  SBAPI.Put(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${profileId}/complementary-items/batch-update`,
    { items }
  )

const deleteMembershipProfileComplementaryItem = (
  complementaryItem: MembershipProfileComplementaryItem
) =>
  SBAPI.Delete(
    `${MEMBERSHIP_PROFILE_COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`
  )

export {
  batchUpdateMembershipProfileComplementaryItems,
  createMembershipProfileComplementaryItem,
  deleteMembershipProfileComplementaryItem,
  fetchMembershipProfileComplementaryItems,
  fetchMembershipProfileComplementaryItemsById,
  updateMembershipProfileComplementaryItem,
}
